var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SystemInformation50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#546E7A",
    d: "M6 8H42V34H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BC34A",
    d: "M8 10H40V31H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M21 34H27V37H21zM33 37c-2 0-16 0-18 0s-2 2-2 2v1h22v-1C35 39 35 37 33 37z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8E9",
    d: "M27.873 15.05L22.182 20.75 19.455 18.03 17.332 20.158 22.186 25 30 17.173z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SystemInformation50);
export default __webpack_public_path__ + "static/media/icons8-system-information-50.89bc077ababfca097d11d149a956a4ac.svg";
export { ForwardRef as ReactComponent };